// extracted by mini-css-extract-plugin
module.exports = {"titleVideoGrid":"VideoWorks_titleVideoGrid__3A-0E"};